<template>
  <v-app syle="max-height: 100vh">
    <v-app-bar app color="third">
        <v-container fluid style="max-height:56px; min-height: 56px; padding: 0px;">
            <v-row style="max-height:inherit; min-height: inherit;" align-content="center">
                <v-col sm="3" style="max-height:inherit;">
                </v-col>
                <v-col sm="6" class="main-logo" style="max-height:inherit; min-height: inherit;">
                    <!--<v-img :src="require('./assets/docma-logo-reversed.svg')" contain max-height="100%"></v-img>-->
                </v-col>
                <v-col sm="3" style="max-height:inherit;">
                    <div class="mx-1" style="float:right; height:100%">
                        <v-icon color="white" v-if="this.loggedIn" @click="logout" style="height: 100%">mdi-exit-run</v-icon>
                    </div>
                    <!--<v-divider v-if="this.loggedIn" class="mx-1" vertical style="float:right; border-color:#616161;" dark></v-divider>-->
                    <!--<div class="mx-1" style="float:right; height:100%">-->
                        <!--<v-icon color="white" v-if="this.loggedIn" @click="openCloseNavDrawer" style="height: 100%">mdi-menu</v-icon>-->
                    <!--</div>-->
                    <v-divider v-if="this.loggedIn && $can_export.get_val()" class="mx-1" vertical style="float:right; border-color:#616161;" dark></v-divider>
                    <div class="mx-1" style="float:right; height:100%">
                        <v-icon color="white" v-if="loggedIn && $can_export.get_val()" style="height: 100%" @click="download_type_selector=true">mdi-download</v-icon>
                    </div>
                    <!--
                    <v-divider v-if="this.loggedIn" class="mx-1" vertical style="float:right; border-color:#616161;" dark></v-divider>
                    <div class="mx-1" style="float:right; height:100%">
                        <a download="Help Guide" :href="pdf_help_guide" >
                            <v-icon color="white" v-if="loggedIn" style="height: 100%">mdi-help</v-icon>
                        </a>
                    </div> -->
                    <v-divider v-if="this.loggedIn && user_can_switch_pricing" class="mx-1" vertical style="float:right; border-color:#616161;" dark></v-divider>
                    <div class="mx-1" style="float:right; height:100%">
                        <v-switch dark hide-details v-if="loggedIn && user_can_switch_pricing" class="ma-0 pa-0" style="height: 100%;" color="white" v-model="pricing_scheme" label="Local Pricing"></v-switch>
                    </div>                    
                </v-col>
            </v-row>
        </v-container>
    </v-app-bar>
    <v-content color="black" style="height: 100vh; width: 100vw; position: fixed">
        <router-view v-on:newApiToken="setApiToken" :apiToken="apiToken" :download="downloading" :download_type="download_type" :download_name="download_name" :pricing_scheme="pricing_scheme" v-on:downloaded="setDownloadPdf"/>
        <v-navigation-drawer
                app
                v-model="navDrawer"
                absolute
                temporary
                right
                :width="userDrawerWidth">
            <!--<profile-drawer></profile-drawer>-->
            <user-profile-drawer :open="navDrawer" v-on:updateDrawerWidth="updateDrawerWidth" :apiToken="apiToken"></user-profile-drawer>
        </v-navigation-drawer>
        <v-overlay :value="help">
            <help-main v-on:closeHelpMenu="help = false;"></help-main>
        </v-overlay>
        <v-overlay :value="download_type_selector">
            <v-card style="padding: 15px;">
                <v-container v-if="downloading" style="height: 100%; width: 100%;">
                    <v-progress-circular indeterminate></v-progress-circular>
                </v-container>
                <v-container v-else style="height: 100%; width: 100%;">
                    <v-row class="ma-0 pa-0" style="width: 100%;">
                        <v-col class="my-0 py-0" sm="12">
                            <v-text-field v-model="download_name" outlined label="Export Name: "></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="ma-0 pa-0" style="width: 100%;">
                        <v-col class="mb-0 pb-0" sm="12">
                            <span>Select a Format:</span>
                        </v-col>
                    <!--</v-row>-->
                    <!--<v-row class="ma-0 pa-0" style="width: 100%;">-->
                        <v-col class="mt-0 pt-0" sm="12">
                            <v-radio-group v-model="download_type">
                                <v-radio label=".pptx Format" value="pptx"></v-radio>
                                <v-radio label=".pdf Format" value="pdf"></v-radio>
                                <v-radio label=".xls Format" value="xls"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row class="ma-0 pa-0" style="width: 100%;">
                        <v-col sm="6">
                            <v-btn v-if="download_type != 'xls'" style="width: 100%; height: 100%;" @click="download()"><v-icon>mdi-download-outline</v-icon></v-btn>
                            <download-excel v-else class="btn btn-default" :fetch="downloadExcel" :fields="excel_export_fields" type="csv" name="SweetSpot.xls">
                                <v-btn style="width: 100%; height: 100%;"><v-icon>mdi-download-outline</v-icon></v-btn>
                            </download-excel>
                        </v-col>
                        <v-col sm="6">
                            <v-btn style="width: 100%; height: 100%;" @click="download_type_selector=false"><v-icon>mdi-close</v-icon></v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-overlay>
        <!--<user-profile-drawer :open="navDrawer"></user-profile-drawer>-->
    </v-content>
  </v-app>
</template>

<script>
    import firebase from 'firebase';
    // import profileDrawer from './components/profileDrawer'
    import userProfileDrawer from './components/userProfileDrawer'
    import api_caller from './javascript/api_caller'
    export default {
        name: 'App',
        components: {
            userProfileDrawer,
        },
        data () {
            return {
                loggedIn: false,
                navDrawer: false,
                apiToken: "",
                profileBoxHeight: 0,
                nameOfUser: '',
                color: '',
                updatedNameOfUser: '',
                updatedColor: '',
                download_type_selector: false,
                downloading: false,
                download_type: 'pptx',
                download_name: '',
                help: false,
                pdf_help_guide: require('@/assets/Getting_Started_Guide.pdf'),
                userDrawerWidth: 312,
                user_can_switch_pricing: null,
                user_can_export: false,
                pricing_scheme: null,
                excel_export_fields: {
                    "Curve Name": "Name",
                    "Target Population": "TargetPop",
                    "Product Quantity": "NumberOf",
                    "Unique Reach": "OnTargetReach",
                    "Unique Reach %": "OnTargetReachPerc",
                    "Average Frequency": "AvgFrequency",
                    "Total Impressions": "Impressions",
                    "Total Budget": "Budget",
                    "GRPs": "GRPS",
                    "CPM": "CPM"
                },
                excel_export_data: []
            }
        },
        mounted () {
            this.isUserLoggedIn()
        },
        updated (){
            this.isUserLoggedIn()
        },
        methods: {
            isUserLoggedIn: function(){
                const currentUser = this.$token.get_val();
                if (currentUser){
                    this.loggedIn = true;
                    if(this.pricing_scheme == null){
                        this.canSwitchPricing(currentUser);
                    }
                    this.canUseSaveFunctionality(currentUser);
                    this.canUseExportFunctionality(currentUser);
                    this.canUseOptimizerFunctionality(currentUser);
                    this.canUseIncrementalReachFunctionality(currentUser);
                }
                else {
                    this.$can_export.set_val(false);
                    this.$can_save.set_val(false);
                    this.$can_optimize.set_val(false);
                    this.$can_find_incremental_reach.set_val(false);
                    this.loggedIn = false
                }
            },
            logout: function(){
                firebase.auth().signOut().then( () => {
                    this.$router.replace('Login')
                })
            },
            download: function(){
                this.downloading = true;
            },
            downloadExcel: async function(){
                this.excel_export_data = [];
                this.downloading = true;
                while(this.downloading){
                    await this.sleep(500);
                }
                return this.excel_export_data;
            },
            setDownloadPdf: function(data){
                if(this.download_type == 'xls'){
                    this.excel_export_data = data;
                }
                this.download_type_selector = false;
                this.downloading = false;
                this.download_name = '';
            },
            openCloseNavDrawer(){
                this.navDrawer = !this.navDrawer;
            },
            setApiToken(token){
                this.apiToken = token;
            },
            updateDrawerWidth(width){
                this.userDrawerWidth = width;
            },
            canSwitchPricing: async function (token){
                let can_switch = await api_caller.can_switch_pricing(token).then((response)=>{
                    console.log(response)
                    return response['authenticated'];
                }).catch((err)=>{
                    console.error(err);
                    return false;
                });
                can_switch = false;
                this.user_can_switch_pricing = can_switch;
                if(this.user_can_switch_pricing){
                    this.pricing_scheme = false;
                }
            },
            canUseSaveFunctionality: async function(token){
                let can_save = await api_caller.can_use_save_functionality(token).then((response)=>{
                    return response['authenticated'];
                }).catch((err)=>{
                    console.error(err);
                    return false;
                });
                can_save = false;
                this.$can_save.set_val(can_save);
            },
            canUseExportFunctionality: async function(token){
                let can_export = await api_caller.can_use_export_functionality(token).then((response)=>{
                    return response['authenticated'];
                }).catch((err)=>{
                    console.error(err);
                    return false;
                })
                this.$can_export.set_val(can_export)
            },
            canUseOptimizerFunctionality: async function(token){
                let can_export = await api_caller.can_use_optimizer_functionality(token).then((response)=>{
                    return response['authenticated'];
                }).catch((err)=>{
                    console.error(err);
                    return false;
                })
                this.$can_optimize.set_val(can_export)
            },
            canUseIncrementalReachFunctionality: async function(token){
                let can_export = await api_caller.can_use_incremental_reach_functionality(token).then((response)=>{
                    return response['authenticated'];
                }).catch((err)=>{
                    console.error(err);
                    return false;
                })
                this.$can_find_incremental_reach.set_val(can_export)
            },            
            sleep: function(ms){
                return new Promise(resolve => setTimeout(resolve, ms));
            },
        }
    };
</script>

<style>

    @import 'css/quebecor/highlights.css';
    @import 'css/quebecor/dataSelector.css';
    @import 'css/quebecor/login.css';
    @import 'css/quebecor/profileDrawer.css';
    @import 'css/quebecor/help.css';
    @import 'css/quebecor/uniqueReachCurveToolTip.css';
    @import 'css/quebecor/configDetails.css';
    @import 'css/quebecor/systemFeedback.css';
    @import 'css/quebecor/home.css';
    /*
    @import 'css/pattison/highlights.css';
    @import 'css/pattison/dataSelector.css';
    @import 'css/pattison/login.css';
    @import 'css/pattison/profileDrawer.css';
    @import 'css/pattison/help.css';
    @import 'css/pattison/uniqueReachCurveToolTip.css';
    @import 'css/pattison/configDetails.css';
    @import 'css/pattison/systemFeedback.css';
    @import 'css/docma/highlights.css';
    @import 'css/docma/dataSelector.css';
    @import 'css/docma/login.css';
    @import 'css/docma/profileDrawer.css';
    @import 'css/docma/help.css';
    @import 'css/docma/uniqueReachCurveToolTip.css';
    @import 'css/docma/configDetails.css';
    @import 'css/docma/systemFeedback.css';
    @import 'css/docma/home.css';
    */
    @import 'css/pattison/save.css';
    @font-face {
        font-family: 'FuturaTLight';
        src: local('FuturaTLight'),
            url('./fonts/futura-t-light.ttf') format('truetype');
    }
    @font-face {
        font-family: 'FuturaTBold';
        src: local('FuturaTBold'),
        url('./fonts/futura-t-bold.ttf') format('truetype');
    }
    @font-face {
        font-family: 'FuturaTMedium';
        src: local('FuturaTMedium'),
        url('./fonts/futura-t-medium.ttf') format('truetype');
    }
    @font-face {
        font-family: 'Calibri';
        src: local('Calibri'), url('./fonts/calibri-regular.ttf')
    }
    @font-face {
        font-family: 'GothamBold';
        src: local('GothamBold'), url('./fonts/GothamBold.otf')
    }
    @font-face {
        font-family: 'GothamMedium';
        src: local('GothamMedium'), url('./fonts/GothamMedium.otf')
    }
    @font-face {
        font-family: 'GothamBook';
        src: local('GothamBook'), url('./fonts/GothamBook.otf')
    }
</style>
